module.exports = __webpack_public_path__ + "img/Waving_Hand.274052ba.png";